module.exports = __webpack_public_path__ + "static/media/text-align-center-black.7b76dac0.svg";